export enum EnumTipoUsuario {
    EnumTipoAdm = 0,
    EnumTipoCliente = 1
}